import React, { useState, useContext, useEffect } from 'react';
import Panel from '../../../../components/Panel';
import FormInput from '../../../../components/FormInput';
import RoundedButton from '../../../../components/RoundedButton';
import PaginatedList from '../../../../components/PaginatedList';
import useAPI from '../../../../hooks/useAPI';
import Utils from '../../../../helpers/Utils';
import { useFormatter } from '../../../../hooks/useFormatter';
import Button from '../../../../components/Button';
import ComponentBusy from '../../../../components/ComponentBusy';
import AuthContext from '../../../../contexts/AuthContext';

export default function SystemViewers () {
    const api = useAPI();
    const formatter = useFormatter();

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});
    const [busy, setBusy] = useState(false);
    const [viewers, setViewers] = useState([]);
    const [loadingViewers, setLoadingViewers] = useState(true);

    const { system } = useContext(AuthContext);

    const handleSendInvite = () => {
        let _errors = {};

        if (!firstName) {
            _errors.first_name = 'First name required.';
        }

        if (!lastName) {
            _errors.last_name = 'Last name required.';
        }

        if (!email) {
            _errors.email = 'Email address required.';
        } else if (!Utils.emailValid(email)) {
            _errors.email = 'Email address invalid.';
        }

        setErrors(_errors);
        if (Object.keys(_errors).length) {
            return;
        }

        setBusy(true);
        api.post('/systems/' + system.id + '/viewers', {
            first_name: firstName,
            last_name: lastName,
            email: email
        })
            .then((r) => r.json())
            .then((r) => {
                if (r.errors) {
                    return setErrors({
                        ...errors,
                        ...formatter.flattenErrors(r.errors)
                    });
                } else {
                    setFirstName('');
                    setLastName('');
                    setEmail('');

                    setViewers(prevViewers => [...prevViewers, r.data]);
                }
            })
            .catch((e) => alert(e))
            .finally(() => setBusy(false));
    };

    const loadViewers = ()=>{
        setLoadingViewers(true);
        api.get('/systems/' + system.id + '/viewers')
          .then((r)=>{
            return r.json();
          }).then((r)=>{
            if(r.data){
                setViewers(r.data || []);
            }else{
                alert('Unable load viewers. Try again later.');
            }
        }).catch((e)=>alert(e))
          .then(()=>setLoadingViewers(false))
    }

    useEffect(()=>{
        loadViewers();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <div className='account-settings'>
                <Panel
                    title="Invite System Viewers"
                    headerStyle={{
                        borderBottomWidth: 1,
                        borderStyle: 'solid',
                        borderColor: '#E2E3E8',
                        paddingBottom: 20
                    }}
                    contentStyle={{
                        paddingTop: 20
                    }}
                >
                    <div className='account-settings--content'>
                        <div className='row'>
                            <div className='col-12 col-lg-6'>
                                <FormInput
                                    label={'First Name'}
                                    required
                                    onChange={(e) => {
                                        setFirstName(e.target.value);
                                        setErrors({
                                            ...errors,
                                            first_name: ''
                                        });
                                    }}
                                    disabled={busy}
                                    value={firstName}
                                    error={errors.first_name}
                                    maxLength="40"
                                />
                            </div>
                            <div className='col-12 col-lg-6'>
                                <FormInput
                                    required
                                    label="Last Name"
                                    onChange={(e) => {
                                        setLastName(e.target.value);
                                        setErrors({
                                            ...errors,
                                            last_name: ''
                                        });
                                    }}
                                    disabled={busy}
                                    value={lastName}
                                    error={errors.last_name}
                                    maxLength="40"
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 col-lg-6'>
                                <FormInput
                                    required
                                    label="Email Address"
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                        setErrors({
                                            ...errors,
                                            email: ''
                                        });
                                    }}
                                    disabled={busy}
                                    value={email}
                                    error={errors.email}
                                    maxLength="100"
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12'>
                                <RoundedButton
                                    solid
                                    onClick={handleSendInvite}
                                    busy={busy}
                                >
                                    Send Invite
                                </RoundedButton>
                            </div>
                        </div>
                    </div>
                </Panel>
            </div>

            <div className='row'>
            {
                viewers.length ?

                <div className='col-12'>
                    <PaginatedList
                        headers={[
                            'First Name',
                            'Last Name',
                            'Email Address',
                            ''
                        ]}
                        items={viewers}
                        render={(viewer)=>{
                           
                            return(
                                <>
                                    <td>
                                        <small>{viewer.first_name}</small>
                                    </td>
                                    <td>
                                        <small>{viewer.last_name}</small>
                                    </td>
                                    <td>
                                        <small>{viewer.email}</small>
                                    </td>
                                    <td style={{fontWeight: 600, color: '#1EB88B'}}>
                                        <span>
                                            <Button
                                                onClick={(e)=>{
                                                    e.preventDefault();
                                                    if(!window.confirm('Are you sure you\'d like to remove this person?')){
                                                        return;
                                                    }

                                                    const _viewers = viewers.filter((v)=>v.id !== viewer.id);
                                                    setViewers(_viewers);

                                                    api.delete('/systems/' + system.id + '/viewers', {
                                                        customer_id: viewer.id
                                                    })
                                                    
                                                }}
                                            >Remove</Button>
                                        </span>
                                    </td>
                                </>
                            );
                        }}
                    />
                </div>
            : (
                
                <div style={{ display: 'flex', padding: 40, flex: 1, justifyContent: 'center', alignItems: 'center', position: 'relative'}}>
                    {loadingViewers ?  <ComponentBusy/> : <span>No System Viewers</span>}
                </div>
            )}
            </div>
        </>
    );
};